<div class="go-to-full-application-dialog">
  <div class="dialog-content">
    <p class="title">{{ 'consumer.quick-quote.dialog.go-to-full-application.title' | translate: lang }}</p>
    <div class="info">
      <p [innerHTML]="'consumer.quick-quote.dialog.go-to-full-application.info-text' | translate: lang"></p>
      <br>
      <p>{{ 'consumer.quick-quote.dialog.go-to-full-application.confirmation-text' | translate: lang }}</p>
    </div>
  </div>
  <div class="alert-buttons-container">
    <button mat-button [id]="'cancel'" (click)="cancelEvent.emit()">
      {{ 'consumer.quick-quote.dialog.go-to-full-application.buttons.cancel' | translate: lang }}
    </button>
    <button mat-button [id]="'continue'" (click)="submitEvent.emit()">
      {{ 'consumer.quick-quote.dialog.go-to-full-application.buttons.continue' | translate: lang }}
    </button>
  </div>
</div>